<template>
  <div class="container">
    <form class="needs-validation" id="page-form" @submit.prevent="validateForm" data-toggle="validator" novalidate>
      <div class="col-12 col-lg-6 center-align">
        <div class="form-group-container">
          <h1 class="page-title text-center icon-title">
            <span class="icon-circle center"><i class="fa fa-unlock" aria-hidden="true"></i></span><span>Verify</span>
          </h1>
          <p v-if="this.authError !== ''" class="error-message">{{ this.authError }}</p>
          <div class="col-12 col-md-12 center-align">
            <div class="form-group row">
              <label for="code" class="col-12 col-lg-4 col-form-label">Code</label>
              <div class="col-12">
                <input type="text" class="form-control" id="code" v-model="code" />
                <Tooltip v-show="this.codeTooltip" helpText="Two factor code. " />
                <div class="bg-danger text-white col-12 clear-padding-left text-danger error-message" v-show="this.errors.hasKey('code')">
                  <span class="" v-text="this.errors.getPropByKey('error', 'code')"></span>
                </div>
              </div>
            </div>

            <div class="form-group row">
              <div class="col-12 col-lg-4"></div>
              <div class="col-12">
                <div class="row">
                  <div class="col-12 col-md-12 login-btns">
                    <button type="submit" class="btn default-btn-color btn-primary">Continue</button>
                  </div>
                  <div class="col-12 col-md-12 forgotten-password">
                    <div class="row">
                      <div class="col-6 text-left">
                        <!-- <router-link class="" to="/register">Register</router-link> -->
                      </div>
                      <div class="col-6 text-right">
                        <router-link class="" to="/forgotten-password">Trouble signing in?</router-link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
/* eslint-disable */
import { authMethods, authComputed, authMutations } from "@/state/helpers";
import Tooltip from "@/components/controls/Tooltip.vue";
import rbValidator from "@/mixins/rbValidator";
import * as Validators from "@/utils/validators";
import * as FormFieldValidators from "@/utils/form-field-validators";
import commonMixin from "@/mixins/commonMixin";
var validations = {
  code: FormFieldValidators.generic_required
};
export default {
  name: "Verify2Fa",
  mixins: [commonMixin, rbValidator],
  components: {
    Tooltip
  },
  data() {
    return {
      code: "",
      email: "",
      validations: validations,
      codeTooltip: false,
      attemptingLogin: false,
      authError: ""
    };
  },
  computed: {
    ...authComputed
  },
  methods: {
    ...authMethods,
    //...authMutations,
    forgottenPassword() {
      this.$router.push("/forgotten-password");
    },
    login() {},
    validateForm(event) {
      event.preventDefault(event);
      this.validate("login-form", this.validations);

      if (this.errors.length === 0) {
        this.canProceed = true;
        //this.$router.push('/my-account');
        this.processVerification();

        return;
      }

      this.canProceed = false;
      this.scrollToTop("page-form");
    },
    async processVerification() {
      this.authError = "";
      var response = await this.VERIFY_2FA({
        code: this.code,
        provider: "Email",
        email: this.currentUserEmail
      });

      if (typeof response.successful !== "undefined" && !response.successful) {
        this.authError = response.error;
      } else {
        if (typeof response.token !== "undefined") {
          if (typeof response.isAdmin !== "undefined" && response.isAdmin) {
            this.$router.push("/admin");
          } else {
            this.$router.push("/my-account");
          }
        }
      }
    }
  },
  mounted() {
    this.email = this.currentUserEmail;
    this.init("login-form", this.validations);
    this.scrollToTop("login-form");
  }
};
</script>

<style scoped>
</style>
